export default "__VITE_ASSET__2ed76346__"